export const environment = {
    production: true,
    urlBack: 'https://maximobuch.api.atalaya.ai/api/v1/',
    urlBackOffice: 'https://maximobuch.atalaya.ai',
    urlFront: 'https://maximobuch.app.atalaya.ai/login',
    client_id: 'Sy5G4uGxrt6TndDPOqHsRspfUSfXCsYqqNu7i3A2',
    client_secret:
        'xhiWcmCevnk12vr5r4cNCi1gOIKzXub9tX3MZs18lhZkjob0w6ylVZCkOLuQTKXldJ0cyYMAmWhLrgPWMH5r77e9FAUJIs4lnwNZlx2iadJ7CCrWHM8bmFSSQZu1WAbx',
};
